import React, { useEffect, useState } from 'react';

import { ProtocolApi } from '../../../../../../../api';
import modalBoxes from '../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../common/general/ButtonGroup';
import { PageInfoHeader } from '../../../../../../PageInfoHeader/PageInfoHeader';
import { generateUrlByKey, useCurrentRoute } from '../../../../../../root/router';
import SaveItemGroupAsTemplateNameChangeModal from '../../../../Protocol/ProtocolSetup/SaveItemGroupAsTemplateNameChangeModal/SaveItemGroupAsTemplateNameChangeModal';
import AddNewItemGroupMenu from '../../../AddNewItemGroupMenu/AddNewItemGroupMenu';

export function ItemGroupDetails({
  isItemGroupTemplate,
  protocolName,
  studyName,
  onSaveData,
  elementName,
  domainCode,
  itemGroupType
}) {
  const {
    parent,
    params: { studyId, protocolIdentity }
  } = useCurrentRoute();

  const [protocolMetaInfo, setProtocolMetaInfo] = useState({});

  useEffect(() => {
    if (studyId && protocolIdentity) {
      ProtocolApi.getPreviewProtocol(studyId, protocolIdentity).then(res => {
        setProtocolMetaInfo(res.data);
      });
    }
  }, [studyId, protocolIdentity]);

  return (
    <PageInfoHeader
      objectRecordLabel={studyName}
      pageInfo={
        <PageInfoHeader.CollapsibleList>
          <PageInfoHeader.AdditionalInfo tooltip="Source Data Name">{protocolName}</PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Version">{protocolMetaInfo.version}</PageInfoHeader.AdditionalInfo>
        </PageInfoHeader.CollapsibleList>
      }
      right={
        <ButtonGroup>
          <Button priority="low" to={navigateBack()}>
            Cancel
          </Button>
          {isItemGroupTemplate ? (
            <Button priority="high" onClick={() => onSaveData()}>
              Save
            </Button>
          ) : (
            <>
              <Button priority="high" onClick={() => onSaveData(true)}>
                Save
              </Button>
              <AddNewItemGroupMenu
                terminologyVersionGroupNumber={protocolMetaInfo?.terminologyVersionGroupNumber}
                handleSave={onSaveData}
              >
                <Button priority="high">Save and New</Button>
              </AddNewItemGroupMenu>
              <Button
                priority="medium"
                onClick={() => {
                  modalBoxes.open({
                    component: (
                      <SaveItemGroupAsTemplateNameChangeModal
                        elementName={elementName}
                        domainCode={domainCode}
                        itemGroupType={itemGroupType}
                        onSaveData={onSaveData}
                      />
                    ),
                    title: 'Template Name'
                  });
                }}
              >
                Save as Template
              </Button>
            </>
          )}
        </ButtonGroup>
      }
    />
  );

  function navigateBack() {
    return generateUrlByKey(parent.key, { studyId, protocolIdentity });
  }
}
